import actions from '../actions';

export const initState = {
  id: null,
  phone: null,
  email: null,
  password: null,
  first_name: null,
  last_name: null,
  gender: null,
  birthday: null,
  country: null,
  city: null,
  zipcode: null,
  photo_url: null,
  authorized: !!localStorage.getItem('personal-account.token'),
  loading: false,

  SignUpStep: 0, // 0=>input phone, 1=>input verification code, 2=>input password, 3=> input other info
  ResetPasswordStep: 0 // 0=>input phone, 1=> input verification code, 2=> input password
};

export default function userReducer(state = initState, action) {
  switch (action.type) {
    case actions.user.SET_STATE:
      return { ...state, ...action.payload };
    default:
      return state;
  }
}
